// app/src/widgets/Footer/Footer.jsx
import React from 'react';
import SocialLinks from '../Header/SocialLinks';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-left">
        <div className="footer-social-wrapper">
          <SocialLinks />
        </div>
      </div>
      <div className="footer-copyright">
        © СОП "ХАКСОН СОФТ" 2013-2026 | MY ULTIMATE GAME CHALLENGE
      </div>
      <div className="footer-right"></div>
    </footer>
  );
};

export default Footer;